diy.angular.registerFactory('diyfmsectionbigstock', [
    '$timeout',
    'diyl10n',
    'diyfmsectionmodel',
    'diyfmsubsectionmodel',
    'diyfmsourcebigstock',
    'diyfmsourcestorage',
    'diyfmconstbigstock',
    'diyfmconstbigstockpurchased',
function(
    $timeout,
    diyl10n,
    diyfmsectionmodel,
    diyfmsubsectionmodel,
    diyfmsourcebigstock,
    diyfmsourcestorage,
    diyfmconstbigstock,
    diyfmconstbigstockpurchased
) {

    // constructor
    var diyfmsectionbigstock = function () {
        diyfmsectionmodel.call(this, 'bigstockSection', diyl10n('filemanager.bigstockSection.title').replace(/&amp;/, '&')); //call parent constructor
    };

    // diyfmsectionbigstock extends diyfmsectionmodel
    diyfmsectionbigstock.prototype = Object.create(diyfmsectionmodel.prototype);

    // static methods
    diyfmsectionbigstock.getOrder = function() {
        return 2;
    };

    // public methods
    angular.extend(diyfmsectionbigstock.prototype, {
        initializeSubsections: function(sources) {
           	// call parent
            diyfmsectionmodel.prototype.initializeSubsections.apply(this, arguments);

            if (sources.indexOf(diyfmsourcebigstock) !== -1) {
                if (diyfmsourcebigstock.isAvailable()) {
                    // all photos section //
                    var bigstockSubsection = new diyfmsubsectionmodel(
                        diyfmconstbigstock,
                        diyl10n('filemanager.bigstockSection.photos'),
                        diyfmsourcebigstock,
                        'bigstockPhotos'
                    );
                    this.addSubsection(bigstockSubsection);

                    // preload first 1000 image because Bigstock API is very slow
                    bigstockSubsection.retrieveItems(0, 200).then(function() {
                        for (var offset = 1; offset < 1000; offset += 200) {
                            bigstockSubsection.retrieveItems(offset, 200);
                        }
                    });

                    // purchased photos section //
                    this.addSubsection(new diyfmsubsectionmodel(
                        diyfmconstbigstockpurchased,
                        diyl10n('filemanager.bigstockSection.purchasedPhotos').replace(/&amp;/, '&'),
                        diyfmsourcestorage,
                        'bigstockPurchasedPhotos',
                        {premium: 1}
                    ));
                }
            }
        }
    });

    return diyfmsectionbigstock;
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sections/diyfmsectionbigstock.js
 ** module id = 963
 ** module chunks = 0
 **/